import axios from '@axios';

const baseAnnouncemnets = '/api/v1/announcements';

export default {
  checkPreCallAnnouncements() {
    return axios.get(`${baseAnnouncemnets}/prison/pre-call-pt/`);
  },
  getAnnouncementWaitingRoom() {
    return axios.get(`${baseAnnouncemnets}/prison/waiting-room-pt/`);
  },
};
